import type { LanguageInfo } from '../types';

/**
 * Language patterns for system programming languages
 */
export const systemLanguagePatterns: LanguageInfo[] = [
  {
    name: 'c',
    patterns: [
      /#include\s*[<"][\w.]+[>"]/,
      /int\s+main\s*\([^)]*\)/,
      /\b(void|int|char|float|double)\s+\w+/,
    ],
    extensions: ['.c', '.h'],
    keywords: ['int', 'char', 'float', 'double', 'void', 'struct', 'enum'],
  },
  {
    name: 'cpp',
    patterns: [
      /#include\s*[<"][\w.]+[>"]/,
      /\b(class|namespace)\s+\w+/,
      /std::\w+/,
    ],
    extensions: ['.cpp', '.hpp', '.cc', '.h'],
    keywords: ['class', 'namespace', 'template', 'typename', 'public', 'private'],
  },
  {
    name: 'rust',
    patterns: [
      /fn\s+\w+/,
      /let\s+mut\s+\w+/,
      /use\s+\w+::/,
    ],
    extensions: ['.rs'],
    keywords: ['fn', 'let', 'mut', 'impl', 'struct', 'enum', 'trait'],
  },
];